import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Config from "../../config";
import User from "../../helpers/login/userData";
import { accountActions } from "../../store/my-account-slice";
import LoadingSpinner from "./LoadingSpinner";

/**
 *
 * @Container props.data{
 * title
 *
 */
const UserAccountData = (props) => {
  if (props.data) {
    var { title } = props.data;
  }
  const userForm = useRef(null);
  const u = User();
  const [user, setUser] = useState(u);
  const [isEditing, setIsEditing] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    state: "",
    zip: "",
    mobile: "",
    dob: "",
    age: "",
    email: "",
    insulin: "yes", // default value
    typeOfDiabetis: "Type 1", // default value
    insulinInjections: "0", // default value
    model: "Pump", // default value
    cgmDevice: "yes", // default value
    typeInsurance: "Private", // default value
    bestTime: "Morning", // default value
  });
  const [statusMessage, setStatusMessage] = useState("");
  const [responseText, setResponseText] = useState("");
  const [responseContainer, setResponseContainer] = useState(null);
  const apiUrl = Config.AscentiaAPI;
  const [statusMessageClassName, setStatusMessageClassName] = useState("");
  const [submitBtn, setSubmitBtn] = useState(null);
  const [age, setAge] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    setUser(u);
  }, [isEditing]);

  const getRequest = (data) => {
    if (Config.GET_USERUPDATE_API)
      axios
        .get(Config.GET_USERUPDATE_API, {
          params: { ...data, userid: user.userid },
        })
        .then((res) => {
          setTimeout(() => {
            setIsEditing(false);
            if (res.data?.success == "true") {
              dispatch(accountActions.replaceAcountInfo(data));
              toast.success("User Information Update Successful", {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
            } else {
              toast.error("Could not update Information", {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
            }
            setIsLoading(false);
          }, 2000);
        })
        .catch((err) => {
          setIsLoading(false);
        });
  };

  const handleChange = (e, key) => {
    if (e.target.name === "dob") {
      setFormData((prev) => ({
        ...prev,
        age: AgeStatus(e.target.value),
      }));
    }
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      [key || e.target.name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isFormDataComplete(formData)) {
      try {
        const response = await fetch(Config.AscentiaApi, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const result = await response.json();
        console.log("Response:", result);
        setStatusMessage(result?.data || "Form submitted successfully!");
        setStatusMessageClassName("success");
        //reset on default
        setFormData({
          firstName: "",
          lastName: "",
          state: "",
          zip: "",
          mobile: "",
          dob: "",
          age: "",
          email: "",
          insulin: "yes", // default value
          typeOfDiabetis: "Type 1", // default value
          insulinInjections: "0", // default value
          model: "Pump", // default value
          cgmDevice: "yes", // default value
          typeInsurance: "Private", // default value
          bestTime: "Morning", // default value
        });
      } catch (error) {
        console.error("Error:", error);
        setStatusMessage("Error submitting form.");
      }
    } else {
      setStatusMessage(getIncompleteFields(formData));
      setStatusMessageClassName("error");
    }
  };

  const AgeStatus = (val) => {
    const dob = new Date(val);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();

    // Adjust age if birthday hasn't occurred yet this year
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return age;
  };
  const isFormDataComplete = (formData) => {
    return Object.values(formData).every(
      (value) => value !== "" && value !== null && value !== undefined
    );
  };

  const getIncompleteFields = (formData) => {
    const incomplete = Object.entries(formData)
      .filter(
        ([_, value]) => value === "" || value === null || value === undefined
      )
      .map(([key]) => key);
    if (incomplete.length === 0) return null;

    return (
      <div className="mt3">
        <h4>Please fill in the following fields:</h4>
        <ul>
          {incomplete.map((key) => (
            <li key={key}>{key}</li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="user-detail card">
      {isLoading && <LoadingSpinner />}
      <div className="user-title">
        <span className="title">{title}</span>
        <Button title="Edit User" onClick={() => setIsEditing(!isEditing)}>
          {!isEditing && <i className="fa-solid fa-pen-to-square"></i>}
          {isEditing && <i className="fa-solid fa-xmark"></i>}
        </Button>
      </div>
      {user && (
        <Form
          className="row form-container"
          onSubmit={handleSubmit}
          ref={userForm}
        >
          {/* {Object.entries(user)
            .filter(([key, value]) => key != "userid")
            .map(([key, value], idx) => {
              if (key === "password") {
                return (
                  <Form.Group className={`mb-3 col-md-6 col-12`} key={idx}>
                    <Form.Label className="text-capitalize">{key}</Form.Label>
                    <div className="password-input">
                      <Form.Control
                        type={showPass ? "text" : "password"}
                        name={key}
                        value={value}
                        onChange={(e) => inputChangeHandler(e, key)}
                        disabled={!isEditing}
                      />
                      <i
                        onClick={() => setShowPass(!showPass)}
                        title={showPass ? "Hide Password" : "Show Password"}
                        className={showPass ? "fas fa-eye-slash" : "fas fa-eye"}
                      ></i>
                    </div>
                  </Form.Group>
                );
              }
              return (
                <Form.Group className={`mb-3 col-md-6 col-12`} key={idx}>
                  <Form.Label className="text-capitalize">{key}</Form.Label>
                  <Form.Control
                    type="text"
                    name={key}
                    onChange={(e) => inputChangeHandler(e, key)}
                    value={value}
                    disabled={!isEditing}
                  />
                </Form.Group>
              );
            })} */}
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">First Name</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              onChange={(e) => handleChange(e, "firstName")}
              disabled={!isEditing}
            />
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">Last Name</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              onChange={(e) => handleChange(e, "lastName")}
              disabled={!isEditing}
            />
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">State</Form.Label>
            <Form.Control
              type="text"
              name="state"
              onChange={(e) => handleChange(e, "state")}
              disabled={!isEditing}
            />
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">ZIP Code</Form.Label>
            <Form.Control
              type="text"
              name="zip"
              onChange={(e) => handleChange(e, "zip")}
              disabled={!isEditing}
            />
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">Email</Form.Label>
            <Form.Control
              type="text"
              name="email"
              onChange={(e) => handleChange(e, "email")}
              disabled={!isEditing}
            />
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">Mobile Number</Form.Label>
            <Form.Control
              type="text"
              name="mobile"
              onChange={(e) => handleChange(e, "mobile")}
              disabled={!isEditing}
            />
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">DOB</Form.Label>
            <Form.Control
              type="date"
              name="dob"
              onChange={(e) => {
                handleChange(e, "dob");
              }}
              disabled={!isEditing}
            />
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">Age</Form.Label>
            <Form.Control
              type="text"
              name="age"
              value={
                !Number.isNaN(AgeStatus(formData.dob))
                  ? AgeStatus(formData.dob)
                  : AgeStatus(formData.dob)
              }
              onChange={(e) => handleChange(e, "age")}
              disabled={!isEditing}
            />
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">Insurence Type</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => handleChange(e, "typeInsurance")}
              disabled={!isEditing}
            >
              <option>Select...</option>
              <option value="Private">Private</option>
              <option value="Commercial">Commercial</option>
              <option value="Employer Insurance">Employer Insurance</option>
              <option value="Medicare">Medicare</option>
              <option value="Advantage">Advantage</option>
              <option value="Medicaid">Medicaid</option>
              <option value="Kaiser">Kaiser</option>
              <option value="Tricare">Tricare</option>
              <option value="VA HEALTH CARE">VA HEALTH CARE</option>
              <option value="No insurance">No insurance</option>
              <option value="Cash pay">Cash pay</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">Diabetis Type</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => handleChange(e, "typeOfDiabetis")}
              disabled={!isEditing}
            >
              <option>Type of Diabetis</option>
              <option value="Type 1">Type 1</option>
              <option value="Type 2">Type 2</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">
              Number of Daily Insulin Injections
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => handleChange(e, "insulinInjections")}
              disabled={!isEditing}
            >
              <option>Choose...</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3+</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">Model</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => handleChange(e, "model")}
              disabled={!isEditing}
            >
              <option>Select model</option>
              <option value="Pump">Pump</option>
              <option value="V-go">V-go</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-6`}>
            <Form.Label className="text-capitalize">
              Have you used CGM device before?
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => handleChange(e, "cgmDevice")}
              disabled={!isEditing}
            >
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className={`mb-3 col-md-6 col-12`}>
            <Form.Label className="text-capitalize">
              Best Time of Contact
            </Form.Label>
            <Form.Control
              type="text"
              name="bestTime"
              placeholder="Morning, afternoons, Working hours, weekends, etc."
              onChange={(e) => handleChange(e, "bestTime")}
              disabled={!isEditing}
            />
          </Form.Group>
          {isEditing && (
            <Button className="col-4 offset-4" type="submit">
              Create Request
            </Button>
          )}
          {statusMessage && (
            <div className="alert alert-success mt-3">{statusMessage}</div>
          )}
        </Form>
      )}
    </div>
  );
};

export default UserAccountData;
